import React from 'react';
import PageTemplate from './PageTemplate';
import { Shield, Lock, Monitor, CheckCircle } from 'lucide-react';
import '../../../../assests/css/customer/Footer/Security.css';
import MyNavbar from '../../Mynavbar/MyNavbar';
import Footer from '../Footer';

const Security = () => {
  const features = [
    {
      icon: <Shield size={32} color="#8B7355" />,
      title: 'Encrypted Transactions',
      description: 'All payment transactions are protected with SSL encryption and 3-D Secure authentication, ensuring your financial data remains completely secure.',
    },
    {
      icon: <Lock size={32} color="#8B7355" />,
      title: 'Data Privacy',
      description: 'We never share, sell, or disclose your personal information to third parties. Your privacy is our commitment, protected by strict security protocols.',
    },
    {
      icon: <Monitor size={32} color="#8B7355" />,
      title: '24/7 Security Monitoring',
      description: 'Our systems are continuously monitored by advanced security tools to detect and prevent suspicious activity, keeping your account safe at all times.',
    },
    {
      icon: <CheckCircle size={32} color="#8B7355" />,
      title: 'Trusted Partners',
      description: 'We collaborate exclusively with verified payment gateways and certified security providers to ensure the highest standards of safety and reliability.',
    },
  ];

  return (
    <>
      <MyNavbar />
      <br />
      <br />
      <br />
      
      <PageTemplate title="Security & Trust">
        <section className="security-hero">
          <h2>Your Security is Our Priority</h2>
          <p>
            At Moonlit, we understand the importance of online safety. That's why we've implemented comprehensive security measures to protect your personal information and ensure every transaction is secure. Shop with complete confidence knowing your data is safeguarded by industry-leading technology.
          </p>
        </section>

        <section className="security-features">
          <h3>Why You Can Trust Moonlit</h3>
          <div className="feature-cards">
            {features.map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">{feature.icon}</div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>
      </PageTemplate>
      
      <Footer />
    </>
  );
};

export default Security;